<template>
  <section class="kiosks-section">
    <Breadcrumbs
      :breadcrumbs="[
        { title: this.$t('menu.audiology'), disabled: true },
        { title: this.$t('menu.kiosks'), disabled: true }
      ]">
      <span slot="breadcrumbAfter" class="d-flex">
        <Searchable
          :querySearch.sync="querySearch"
          :searchTooltip="{
            placement: 'left',
            content: this.$t('search.term')
          }" />
        <Filters
          :isActive="showFilters"
          :activeFilters="activeFilters"
          @toggle-filters="showFilters = !showFilters"
        />

      </span>
    </Breadcrumbs>

    <div class="btn btn__floating btn__round__large" v-if="hasWritePermissions">
      <va-button
        @click.prevent="createLicense">
        <i class="fa fa-plus"></i>
      </va-button>
    </div>

    <TableView
      ref="kiosksTableView"
      :query-search="querySearch"
      :custom-queries.sync="customQueries"
      :show-filters="showFilters"
      @filters-updated="onFiltersUpdated" />

      <CreateOrUpdateLicense
        v-if="isCreatingLicense"
        @created="refreshTable"
        @updated="refreshTable"
        @destroyed="refreshTable"
        @modalClosed="onCreateLicenseModalClosed" />

  </section>

</template>
<script>
import Filters from '@/components/common/Filters'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import Searchable from '@/components/common/Searchable'
import TableView from './TableView'
import CreateOrUpdateLicense from '@/components/licenses/CreateOrUpdate'
import LocalStorageHelper from "@/local-storage/LocalStorageHelper";
import {TABLE_LICENSE_KIOSKS} from "@/local-storage/LocalStorageKeys";
import IndexTablesMixin from "@/mixins/IndexTablesMixin";
const licenseInfoType = 300
const WriteAccessType = 2
export default {
  mixins:[
    IndexTablesMixin
  ],
  components: {
    Filters,
    Breadcrumbs,
    Searchable,
    TableView,
    CreateOrUpdateLicense
  },
  computed: {
    leadsService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.evollead_server)
    },
    hasWritePermissions: function () {
      return this.leadsService.user_permissions.some(permission => permission.info_type === licenseInfoType && permission.access_type >= WriteAccessType)
    }
  },

  data: function () {
    return {
      isCreatingLicense: false,
      querySearch: '',
      showFilters: false,
      activeFilters: 0,
      customQueries: {},
      localStorageKey: TABLE_LICENSE_KIOSKS
    }
  },
  methods: {
    onFiltersUpdated: function (activeFilters) {
      this.activeFilters = activeFilters
    },
    createLicense: function () {
      this.isCreatingLicense = true
    },
    onCreateLicenseModalClosed: function () {
      this.isCreatingLicense = false
    },
    refreshTable: function () {
      this.$refs.kiosksTableView.refreshTable()
    },
    /*loadLocalStorage: function () {
      let state = LocalStorageHelper.get(TABLE_LICENSE_KIOSKS)
      if (state) {
        if(state.query){
          this.querySearch = state.query;
        }

        if(state.customQueries){
          this.customQueries = state.customQueries
        }
      }
    },*/
  }
}
</script>

<style lang="scss">

.fa-pencil.custom-pencil{
  cursor: pointer;
  color: #29c4a9;
  font-size: 0.75em;
}

.icons-wrapper{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 20px;
  margin-top: 10px;
}

.slide-transition-enter-active, .component-fade-leave-active {
  transition: opacity 1s ease;
}
.slide-transition-enter, .component-fade-leave-to
/* .component-fade-leave-active-appointments below version 2.1.8 */ {
  opacity: 0;
}

</style>
